import React, { ReactNode } from "react";
import { useSignal, viewport } from "@telegram-apps/sdk-react";
import cn from "classnames";
import cls from "./styles.module.scss";

export default function WebAppContainer({
  children,
  className,
  ignore,
  usePadding,
}: {
  children: ReactNode;
  className?: string;
  ignore?: boolean;
  usePadding?: boolean;
}) {
  const insetTop = useSignal(viewport.safeAreaInsetTop);
  const contentInsetTop = useSignal(viewport.contentSafeAreaInsetTop);
  const insetBottom = useSignal(viewport.safeAreaInsetBottom);
  const contentInsetBottom = useSignal(viewport.contentSafeAreaInsetBottom);

  const insetType = usePadding ? "padding" : "margin";

  return (
    <div
      style={{
        [`${insetType}Top`]: ignore ? "0" : `${insetTop + contentInsetTop}px`,
        [`${insetType}Bottom`]: ignore
          ? "0"
          : `${insetBottom + contentInsetBottom}px`,
      }}
      className={cn(cls.wrapper, className)}
    >
      {children}
    </div>
  );
}
